export const SET_PRINTERS = 'SET_PRINTERS';
export const setPrinters = cards => ({
  type: SET_PRINTERS,
  cards,
});

export const SET_SETTINGS_PAGE = 'SET_SETTINGS_PAGE';

export const SET_INVITES_SENT = 'SET_INVITES_SENT';
export const SET_INVITE_ERROR = 'SET_INVITE_ERROR';
export const SET_PENDING_INVITES = 'SET_PENDING_INVITES';
export const SET_USER_INVITE_ACCEPT_PAGE = 'SET_USER_INVITE_ACCEPT_PAGE';

export const SET_ACCESS_UPDATED = 'SET_ACCESS_UPDATED';
export const SET_ACCESS_UPDATED_ERROR = 'SET_ACCESS_UPDATED_ERROR';

export const SET_USER_PAYMENT_METHODS = 'SET_USER_PAYMENT_METHODS';
export const UPDATE_CREDIT_CARD = 'UPDATE_CREDIT_CARD';
export const UPDATE_CREDIT_CARD_ERROR = 'UPDATE_CREDIT_CARD_ERROR';
export const SET_USER_PURCHASE_HISTORY = 'SET_USER_PURCHASE_HISTORY';



// WEBPACK FOOTER //
// ./app/actions/account-settings.js